module.exports = __webpack_public_path__ + "img/Feature.18e80f64.jpg";